import React from "react"
import Footer from "../components/Footer"
import Header from "../components/Header"
import { connect } from "react-redux"
import ProtectedContent from "./ProtectedContent"

class ResourcesSuspended extends React.Component {
  /*componentDidMount() {
    const user = netlifyIdentity.currentUser()
    if (user === null) {
      netlifyIdentity.open()
    }
  }*/

  render() {
    return (
      <div>
        <Header />

        <div className="container">
          {Object.keys(this.props.user).length ? (
            <div>
              <h1 style={{ marginTop: "30px", textAlign: "center" }}>
                Teaching Resources
              </h1>
              <p style={{ textAlign: "center", marginBottom: "80px" }}>
                The new 2021-22 teaching resources will be available very soon.
              </p>
            </div>
          ) : (
            <ProtectedContent />
          )}
        </div>

        <Footer />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  }
}

export default connect(mapStateToProps)(ResourcesSuspended)



// WEBPACK FOOTER //
// ./src/components/ResourcesSuspended.js